export default __webpack_public_path__ + "static/media/medicine.f0e550d2.svg";